module.exports = __webpack_public_path__ + "static/img/by.12097dbd.svg";